import React, {Fragment, useEffect, useState} from "react";
import {Modal, ModalBody, Row, Col} from 'reactstrap';
import ToastBox from "../../../common/ToastBox";
import {ToastMsg} from "../../../constant/ToastMsg";
import {isIterableArray} from "../../../../utils/common";
import ConfirmModal from "../../../common/ConfirmModal";
import {useDispatch, useSelector} from "react-redux";
import {checkErrorResponse} from "../../../../helpers/errorCheck";
import {Slider} from "@material-ui/core";
import upgradeArrow from '../../../../assets/img/product/upgradeArrow.svg';
import {Alert, AlertTitle} from "@mui/lab";
import {Button} from "@mui/material";
import {getGamePlanList, upgradeGamePlan} from "../../action";

const GameChangePlanModal = ({modal, toggle, mcNo, id}) => {
    const dispatch = useDispatch();
    const [planStep, setPlanStep] = useState(0);
    const {upgradePlans, currentPlan} = useSelector(state => state.gameDeploy);

    const handleChangeHostingPlan = () => {
        return new Promise((resolve, reject) => {
            const planId = upgradePlans[planStep].gmp_id;
            upgradeGamePlan(mcNo, planId).then(response => {
                if (response) {
                    if (response.request.status === 200) {
                        resolve(true);
                        toggle();
                        setTimeout(() => {
                            window.location.href = `/gameManage/${mcNo}/${id}`;
                        }, 1000)


                    }
                }
            }).catch(err => {
                checkErrorResponse(err);
                reject(err);
            })
        })
    };

    useEffect(() => {
        if (modal) {
            getGamePlanList(mcNo).then(response => {
                if (response) {
                    if (response.request.status === 200) {
                        dispatch(response);
                    }
                }
            }).catch(err => {
                checkErrorResponse(err);
            })
        }
    }, [modal]);

    const handleChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            setPlanStep(newValue);
        }
    };
    return (
        <Modal centered isOpen={modal} toggle={toggle} className='game_hosting_plan_modal' id={'game_hosting_modal'}>
            <ModalBody>
                <div className='change_plan_wrapper'>
                    <div className='change_plan_title'>
                        <h4>요금제 변경</h4>
                        <div onClick={toggle} className="close close3"/>
                    </div>
                    {isIterableArray(upgradePlans) ?
                        <Fragment>
                            <ToastBox type={'warning'} title={'경고'} text={ToastMsg.ChangeGamePlanMsg}/>
                            <div className='use_plan_txt py-2'>
                                <Row>
                                    <Col xs={7}>
                                        <div className='use_plan_now'>
                                            {/*<span>{`현재 요금 : ${(currentPlan.cp_monthly_cost).toLocaleString()} P/월`}</span>*/}
                                            {/*<small>{`(${(currentPlan.cp_day_cost).toLocaleString()} P/일)`}</small>*/}
                                        </div>
                                        <div className='use_plan_upgrade'>
                                            {/*<span>{`업그레이드 요금 : ${(upgradePlans[planStep].cp_monthly_cost).toLocaleString()} P/월`}</span>*/}
                                            {/*<small>{`(${(upgradePlans[planStep].cp_day_cost).toLocaleString()} P/일)`}</small>*/}
                                        </div>

                                    </Col>
                                    <Col xs={5}>
                                        <div className='use_plan_compare'>
                                            {/*<h4>{`+${(upgradePlans[planStep].cp_monthly_cost) - (currentPlan.cp_monthly_cost)} P/월`}</h4>*/}
                                            {/*<span>{`+${(upgradePlans[planStep].cp_day_cost) - (currentPlan.cp_day_cost)} P/일`}</span>*/}
                                        </div>
                                    </Col>
                                </Row>


                            </div>
                            <div style={{marginTop: '1.5rem'}}>
                                <Fragment>
                                    <Slider
                                        color={'secondary'}
                                        aria-label="PlanInfo"
                                        defaultValue={0}
                                        valueLabelDisplay="auto"
                                        onChange={handleChange}
                                        step={1}
                                        marks
                                        min={0}
                                        max={upgradePlans.length - 1}
                                    />
                                    <div className='plan_info_wrapper'>
                                        <span>요금제 정보</span>
                                        <Row className='plan_info_box'>
                                            <Col xs={12} lg={5} className='now_plan_info'>
                                                <Row>
                                                    <Col xs={6} className='plan_key_list fw-bold'>
                                                        <span>MAX PLAYER : </span>
                                                        <span>MEMORY : </span>
                                                        <span>DDOS : </span>
                                                        <span>TRAFFIC : </span>

                                                    </Col>
                                                    <Col xs={6} className='plan_key_list' style={{textAlign: 'right'}}>
                                                        <span>{currentPlan.gmp_max_player} 명</span>
                                                        <span>{currentPlan.gmp_memory} MB</span>
                                                        <span>무제한</span>
                                                        <span>무제한</span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} lg={2} className='text-center'>
                                                <img id={'upgrade_arrow_img'} className='w-75' src={upgradeArrow} alt={'upgrade_arrow'}/>
                                            </Col>
                                            <Col xs={12} lg={5} className='upgrade_plan_info'>
                                                <Row>
                                                    <Col xs={6} className='plan_key_list fw-bold'>
                                                        <span>MAX PLAYER : </span>
                                                        <span>MEMORY : </span>
                                                        <span>DDOS : </span>
                                                        <span>TRAFFIC : </span>
                                                    </Col>
                                                    <Col xs={6} className='plan_key_list' style={{textAlign: 'right'}}>
                                                        <span>{upgradePlans[planStep].gmp_max_player} 명</span>
                                                        <span>{upgradePlans[planStep].gmp_memory} MB</span>
                                                        <span>무제한</span>
                                                        <span>무제한</span>
                                                    </Col>
                                                </Row>
                                            </Col>

                                        </Row>
                                    </div>
                                </Fragment>
                                <ConfirmModal
                                    fullWidth
                                    color={'primary'}
                                    variant={'contained'}
                                    type={'gameUpgradePlan'}
                                    handleEvent={handleChangeHostingPlan}/>
                            </div>
                        </Fragment>
                        :
                        <Fragment>
                            <Alert severity="info">
                                <AlertTitle>알림</AlertTitle>
                                <span>더 이상 업그레이드 가능한 요금제가 존재하지 않습니다.</span>
                            </Alert>
                            <Button onClick={toggle} fullWidth color={'primary'} variant={'contained'}>닫기</Button>
                        </Fragment>
                    }
                </div>
            </ModalBody>

        </Modal>
    );
}

export default GameChangePlanModal;
